module.exports = __webpack_public_path__ + "static/media/smoking-ban.935654a0.svg";